import React, { useState, useEffect, useCallback } from 'react';
import Record from "./Record";
import "./RecordTable.css";
import axios from 'axios';
import config from "../../config";
import { useNavigate } from 'react-router-dom';

const RecordTable = () => {
  const [records, setRecords] = useState([]);
  const navigate = useNavigate();

  const fetchRecords = useCallback(() => {
    const userId = localStorage.getItem('user_id');
  
    if (!userId) {
      console.error('No user_id found in localStorage');
      navigate("/signin");
    }
  
    axios.get(`${config.apiUrl}/api/experiment/`, {
      params: { user_id: userId }
    })
      .then(response => {
        console.log("response.data");
        setRecords(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the records!', error);
      });
  }, [navigate, setRecords]);
  
  useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  const handleDeleteRecord = (recordId) => {
    axios.delete(`${config.apiUrl}/api/experiment/${recordId}`)
      .then(response => {
        setRecords(records.filter(record => record.id !== recordId));
      })
      .catch(error => {
        console.error('There was an error!', error);
      });
  };

  const handleCloneRecord = (recordId) => {
    axios.get(`${config.apiUrl}/api/experiment/${recordId}/clone`)
      .then(response => {
        fetchRecords(); // Fetch updated records after cloning
      })
      .catch(error => {
        console.error('There was an error!', error);
      });
  };

  return (
    <div className="recordTable">
      {records.length === 0 ? (
        <section id="no-analysis" className='norecords__lable'>
          <p>You have no analysis. To start a new analysis click "New Experiment" button</p>
    </section>
      ) : (
        records.map((record, index) => (
          <Record 
            key={index} 
            record={record} 
            onDelete={handleDeleteRecord} 
            onClone={handleCloneRecord} 
          />
        ))
      )}
    </div>
  );
};

export default RecordTable;
